export default __webpack_public_path__ + "655bcfaeecf10b45f8b49a998045a227.svg";